// extracted by mini-css-extract-plugin
export default {"contentCard":"contentCard_contentCard__k5tGE","contentName":"contentCard_contentName__rKECJ","actions":"contentCard_actions__1zJiK","newEntry":"contentCard_newEntry__ilQSh"};